// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_on-0";
export var discountCodeInput = "_on-1";